import { CoverImage } from '@seek/branding-assets';
import { Bleed, Loader } from 'braid-design-system';
import type { CompanyProfile } from '../../../';
import { Section } from '../../common/section/Section';

export type CompanyBrandingSectionModel = Pick<
  CompanyProfile,
  'branding' | 'name' | 'rating' | 'id' | 'zone'
>;

interface Props {
  loading?: boolean;
  model?: Omit<CompanyBrandingSectionModel, 'id'>;
}

const createImageObject = (propertyName: string, imageUrl?: string) => ({
  url: imageUrl || '',
  strategies: {
    [propertyName]: imageUrl || '',
  },
  id: imageUrl || '',
});

/**
 * This is a view mode component
 */
export function CompanyBrandingSection({ model, loading }: Props) {
  if (loading) {
    return <Loader />;
  }

  const coverImageAsset = createImageObject(
    'jdpCover',
    model?.branding?.coverImageUrl,
  );

  return (
    <Section mode="view" loading={loading}>
      <Bleed
        horizontal={{ mobile: 'xsmall', tablet: 'none', desktop: 'large' }}
        top="xxsmall"
      >
        <CoverImage cover={coverImageAsset} roundedCorners />
      </Bleed>
    </Section>
  );
}
